import PublishFooter from './PublishFooter';

export default PublishFooter;
